import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeContext } from 'styled-components';
import Preview from './preview';

const Article = styled.article`
  display: flex;
  flex-direction: ${props => (props.theme.isPortrait ? 'column' : 'row-reverse')};
  padding: ${props => (props.theme.isPortrait ? '42px 20px 0 20px' : '135px 0 0 0')};
  justify-content: center;

  &:after {
    order: -1;
    content: "";
    position: realtive;
    height: auto;
    width: 11.4vw;
    max-width: 164px;
  }
`;

const TextContainer = styled.div`
  order: -2;
  max-width: ${props => (props.theme.isPortrait ? 'none' : '524px')};
  width: ${props => (props.theme.isPortrait ? 'auto' : '36.4vw')};
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
`;

const Title = styled.h5`
  font-family: ${props => props.theme.fontFamilyBody};
  text-transform: uppercase;
  color: ${props => props.theme.primaryColor};
  font-weight: ${props => props.theme.fontWeightHeavy};
  font-size: ${props => (props.theme.isPortrait ? 15 : 20)}px;
  margin: 0;
`;

const Header = styled.h1`
  font-family: ${props => props.theme.fontFamilyHeader};
  font-size: ${props => (props.theme.isPortrait ? 30 : 40)}px;
  line-height: ${props => (props.theme.isPortrait ? 40 : 47)}px;
  color: #000;
  margin: ${props => (props.theme.isPortrait ? '10px 0' : '20px 0')};
`;

const Desc = styled.p`
  font-family: ${props => props.theme.fontFamilyBody};
  color: #000;
  font-size: 15px;
  line-height: 20px;
  max-width: ${props => (props.theme.isPortrait ? 'none' : '412px')};
  width: ${props => (props.theme.isPortrait ? 'auto' : '28.6vw')};
  margin: 0;
`;

const Ul = styled.ul`
  display: inline-block;
  list-style: none;
  font-size: 15px;
  line-height: 25px;
  padding: 0;
  margin-top: 40px;
  margin-bottom: 0;

  > li::before {
    content: "\u2022";
    display: inline-block;
    font-size: 32px;
    line-height: 20px;
    position: relative;
    top: 3px; /* (font-size(32px) - line-height(20px)) / 2 */
    color: ${props => props.theme.primaryColor};
    margin-left: 20px;
    margin-right: 15px;
  }
`;

export default function WhatIsInside({ inside }) {
  const { isPortrait } = React.useContext(ThemeContext);
  const { title, desc, bullets } = inside;

  return (
    <Article>
      <TextContainer>
        <Title>what’s inside</Title>
        <Header>{title}</Header>
        <Desc>{desc}</Desc>
        {!isPortrait && (
          <Ul>
            {bullets.map(item => <li key={item}>{item}</li>)}
          </Ul>
        )}
      </TextContainer>
      <Preview />
    </Article>
  );
}

WhatIsInside.propTypes = {
  inside: PropTypes.shape({
    title: PropTypes.string.isRequired,
    desc: PropTypes.string.isRequired,
    bullets: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
};
